/* eslint-disable @typescript-eslint/no-floating-promises */
/* istanbul ignore file */

import Logger from "@next/core-logger"
import React from "react"
import {hydrateRoot} from "react-dom/client"
import {Provider} from "react-redux"
import {createEmotionCache} from "@next/emotion-cache"
import {CacheProvider} from "@emotion/react"
import App from "../App"
import {getProps, getState, getStore} from "./utils"
import {PLP_ID} from "../config/constants"
import "./polyfill"

const state = getState()
const appProps = getProps()
const store = getStore(state)
const cache = createEmotionCache({key: "plp", rtl: appProps.textAlignment === "rtl"})
const reactDom = () => {
    Logger.debug(`Hydrating PLP `)
    const rootElement = document.getElementById(PLP_ID)
    if (!rootElement) {
        throw new Error("PLP root element not found")
    }

    hydrateRoot(
        rootElement,
        <Provider store={store} serverState={state}>
            <CacheProvider value={cache}>
                <App {...appProps} />
            </CacheProvider>
        </Provider>,
    )
}
window.addEventListener("hydrate-chunks-plp", reactDom)
